import React, { useState, useMemo } from 'react';
import {
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography,
    useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import StaticBackground from './StaticBackground';
import Tile from './EmptyStateTile';
import getTile from './EmptyStateGetTiles';
import useResponsive from '../hooks/useResponsive';

import {
    setSelectedTileId,
    clearSelectedTileId,
} from '../reducers/uiReducer';
import { useDispatch, useSelector } from 'react-redux';

import { NewChatIcon } from '../assets/SvgIcons';

const newChatTile = {
    id: 'analyze_document',
    title: 'Start New Chat',
    tileType: 'NewChat',
    description: 'Create a new chat.',
    extendedDescription: '...',
    action: 'newChat',
    icon: <NewChatIcon width={100} height={100} />,
};

const EmptyStateTiles = ({ config, setPromptCallBack, onSelectTile }) => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const { isDesktopScreen, isTableScreen, isMobileScreen } = useResponsive();

    const [open, setOpen] = useState(false);
    const ui = useSelector((state) => state.ui);
    const selectedTileId = ui.selectedTileId;
    const selectedTile = config.tiles.find((tile) => tile.id === selectedTileId);

    const handleOpen = () => setOpen(true);

    const handleClose = () => {
        setOpen(false);
        dispatch(clearSelectedTileId());
    };

    const memoizedBackground = useMemo(
        () => <StaticBackground numShapes={30} />,
        []
    );

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                padding: 2,
                overflow: 'auto',
                position: 'relative',
                // backgroundColor: theme.palette.background.default,
            }}
        >
            {memoizedBackground}
            {selectedTileId === null ? (
                <Box
                    sx={{
                        display: 'grid',
                        gap: 3,
                        maxWidth: '800px',
                        animation: 'fadeIn 0.2s ease-in forwards',
                        transition: 'opacity 0.2s ease',
                        opacity: 1,
                        gridTemplateColumns: isDesktopScreen
                            ? 'repeat(3, 1fr)'
                            : isTableScreen
                                ? 'repeat(3, 1fr)'
                                : 'repeat(2, 1fr)',
                        '@keyframes fadeIn': {
                            from: { opacity: 0 },
                            to: { opacity: 1 },
                        },
                    }}
                >
                    {[...config.tiles, newChatTile].map((tile) => (
                        <Tile
                            key={tile.id}
                            tile={tile}
                            handleTileClick={() => onSelectTile(tile)}
                            handleOpen={handleOpen}
                            hideDescription
                        // sx={{
                        //     border:
                        //         selectedTileId === tile.id
                        //             ? `2px solid ${theme.palette.primary.main}`
                        //             : 'none',
                        //     width: isMobileScreen ? '50px' : '200px',
                        // }}
                        />
                    ))}
                </Box>
            ) : (
                !open && getTile(selectedTile, handleClose, setPromptCallBack)
            )}

            <Dialog open={open} onClose={handleClose} aria-labelledby="tile-dialog-title">
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        p: 2,
                        backgroundColor: theme.palette.background.paper,
                    }}
                >
                    {selectedTile?.title}
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{ position: 'absolute', top: 8, right: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        p: 4,
                        backgroundColor: theme.palette.background.default,
                    }}
                >
                    {selectedTile && (
                        <>
                            <Box>{selectedTile.icon || <InfoIcon fontSize="large" />}</Box>
                            <Typography variant="body1">{selectedTile.extendedDescription}</Typography>
                        </>
                    )}
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default EmptyStateTiles;
